import { ACTION } from './project_ac_central_actions';
import {
  list_reducer,
  add_reducer,
  delete_reducer,
} from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  filteredCount: 0,
  isLoading: false,
  isCreating: false,
  isDeleting: false,
  errorMessage: null,
  // For mixed use project ac_central_groups
  groups: [],
  isGroupsLoading: false,
  groupsErrorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        ...list_reducer(state, action),
        isLoading: false,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.CREATE}_PENDING`:
      return {
        ...state,
        isCreating: true,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_FULFILLED`:
      return {
        ...state,
        ...add_reducer(state, action),
        isCreating: false,
      };
    case `${ACTION.CREATE}_REJECTED`:
      return {
        ...state,
        isCreating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.BIND}_PENDING`:
      return {
        ...state,
        isCreating: true,
        errorMessage: null,
      };
    case `${ACTION.BIND}_FULFILLED`:
      return {
        ...state,
        isCreating: false,
      };
    case `${ACTION.BIND}_REJECTED`:
      return {
        ...state,
        isCreating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DELETE}_PENDING`:
      return {
        ...state,
        isDeleting: true,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_FULFILLED`:
      return {
        ...state,
        ...delete_reducer(state, action),
        isDeleting: false,
      };
    case `${ACTION.DELETE}_REJECTED`:
      return {
        ...state,
        isDeleting: false,
        errorMessage: action.payload,
      };
    case `${ACTION.UNBIND_GROUP}_PENDING`:
      return {
        ...state,
        isDeleting: true,
        errorMessage: null,
      };
    case `${ACTION.UNBIND_GROUP}_FULFILLED`:
      return {
        ...state,
        isDeleting: false,
      };
    case `${ACTION.UNBIND_GROUP}_REJECTED`:
      return {
        ...state,
        isDeleting: false,
        errorMessage: action.payload,
      };
    case `${ACTION.LIST_GROUPS}_PENDING`:
      return {
        ...state,
        isGroupsLoading: true,
        groupsErrorMessage: null,
      };
    case `${ACTION.LIST_GROUPS}_FULFILLED`:
      return {
        ...state,
        groups: action.payload,
        isGroupsLoading: false,
      };
    case `${ACTION.LIST_GROUPS}_REJECTED`:
      return {
        ...state,
        isGroupsLoading: false,
        groupsErrorMessage: action.payload,
      };
    case ACTION.CLEAR_ERROR:
      return {
        ...state,
        errorMessage: null,
        groupsErrorMessage: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/projects/project_ac_central_reducers.js